import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import "dayjs/locale/ar";

import messages from "../../../assets/locale/messages";
import { UIIcon } from "../../ui";
import PaymentNotice from "../../Events/Event/PaymentNotice";

import "./_CompanyDeactivationBanner.scss";

/** The Super Admin's view of why and when a company was deactivated. The company never sees it. */
const CompanyDeactivationBanner = ({ reason, deactivatedAt }) => {
  const lang = useSelector((state) => state.locale.lang);
  const t = messages[lang].companiesList.deactivation;
  // Parse only the date portion, so the UTC+3 offset can't shift the day near midnight.
  const date = dayjs(deactivatedAt.substring(0, 10))
    .locale(lang === "ar" ? "ar" : "en")
    .format("D MMMM YYYY");

  return (
    <PaymentNotice
      variant="error"
      className="company-deactivation-banner"
      icon={
        <UIIcon
          name="alertCircle"
          width={20}
          height={20}
          color="currentColor"
          strokeWidth={3.11}
          decorative
        />
      }
      title={t.detailsTitle}
      description={
        <>
          {/* Typed in either language: lines start on the page's side and read in their own direction. */}
          <div className="company-deactivation-banner__reason">
            <bdi>{reason}</bdi>
          </div>
          <div className="company-deactivation-banner__date">
            <span className="company-deactivation-banner__date-label">{t.detailsDateLabel}</span>{" "}
            {date}
          </div>
        </>
      }
    />
  );
};

CompanyDeactivationBanner.propTypes = {
  reason: PropTypes.string.isRequired,
  deactivatedAt: PropTypes.string.isRequired,
};

export default CompanyDeactivationBanner;
